<template>
  <div class="match">
    <van-nav-bar title="员工认证" left-arrow @click-left="back" />
    <div class="wrap">
      <p>根据手机号匹配到您的员工信息如下</p>
      <div class="msg_wrap">
        <p>
          <span>员工姓名：</span>
          {{ userInfo.name }}
        </p>
        <p>
          <span>手机号码：</span>
          {{
            userInfo.phone
          }}
        </p>
        <p>
          <span>公司名称：</span>
          {{ userInfo.company || '无' }}
        </p>
        <p>
          <span>所在大厦：</span>
          {{ userInfo.edifice || '无' }}
        </p>
        <p>
          <span>所在楼层：</span>
          {{ userInfo.floor || '无' }}
        </p>
        <p v-if="userInfo.unitList">
          <span>单元号：</span>
          <i v-for="(item,index) in JSON.parse(userInfo.unitList)" :key="index">
            {{ item }}
            <i v-if="index<JSON.parse(userInfo.unitList).length-1">,</i>
          </i>
        </p>
      </div>
      <van-button class="sub_btn" type="info" @click="onMatch">确认认证</van-button>
    </div>
  </div>
</template>

<script>
import { staffCertification } from '@/api/home'
export default {
  name: 'Match',
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem('staffInfo'))
    }
  },
  created() {

  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    onMatch() {
      const data = {}
      staffCertification(data).then(res => {
        this.$router.push({ name: 'user' })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.match {
  i {
    font-style: normal;
  }
  .wrap {
    padding: 0.2rem 0.15rem;
    .msg_wrap {
      background: #fff;
      width: 87%;
      margin: 0.15rem auto;
      padding: 0.13rem 0.2rem;
      span {
        display: inline-block;
        width: 0.8rem;
      }
      p {
        line-height: 0.3rem;
      }
      border: 1px solid rgba(239, 239, 244, 1);
      box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
      border-radius: 6px;
    }
  }
}
</style>
